import DepsService from 'services/dependencies';

const CONTEXT = 'privilegeTemplates';

const fetchPrivileges = (userClass, retailerType) => {
  const urlParams = { userClass };
  const queryParams = retailerType ? { retailerType } : null;

  const { url } = DepsService.rest.privileges.dynamic;

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

const fetchPrivilegeTemplates = (userClass, retailerType) => {
  const urlParams = { userClass };
  const queryParams = retailerType ? { retailerType } : null;

  const { url } = DepsService.rest.privileges.roles.list;

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

const createPrivilegeTemplate = ({ userClass, translations, privileges }) => {
  const urlParams = { userClass };
  const date = new Date().getTime();
  const payload = {
    privileges,
    translations,
    creationDatetime: date,
    modificationDatetime: date,
  };

  const { url } = DepsService.rest.privileges.roles.create;

  return DepsService.restSrv.create(CONTEXT, url, payload, urlParams);
};

const deletePrivilegeTemplate = (id) => {
  const urlParams = { id };

  const { url } = DepsService.rest.privileges.roles.delete;

  return DepsService.restSrv.remove(CONTEXT, url, urlParams);
};

const updatePrivilegeTemplate = ({ id, ...data }) => {
  const urlParams = { id };
  const payload = { ...data };

  const { url } = DepsService.rest.privileges.roles.update;

  return DepsService.restSrv.update(CONTEXT, url, payload, urlParams);
};

export default {
  fetchPrivilegeTemplates,
  createPrivilegeTemplate,
  deletePrivilegeTemplate,
  updatePrivilegeTemplate,
  fetchPrivileges,
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/resources/privilege-templates.api.js